type Props = {
  showKioskConfigurationPage?: boolean,
  showSplashScreen?: boolean,
  storeShowDiningTypePage?: boolean,
};

export function getKioskRedirectPath({
  showKioskConfigurationPage,
  showSplashScreen,
  storeShowDiningTypePage,
}: Props = {}) {
  if (showSplashScreen) {
    return 'kiosk.store.splash-screen';
  }

  if (showKioskConfigurationPage) {
    return 'kiosk.store.config';
  }

  if (storeShowDiningTypePage) {
    return 'kiosk.store.dining-type';
  }

  return 'kiosk.store.menu.overview';
}
